export class LoginEndpointResponse {
  access_token!: string;
  refresh_token!: string;
  sub!: string;
  iat!: number;
  exp!: number;
}
